import BaseApi from './../../libraries/baseApi';

export default class Api extends BaseApi {
    constructor() {
        super();
        this.test = false;
        this.url = '/umbraco/api/productselectorapi/';
    }

    GetOptions(data) {
        return super.fetch(
            'GetOptions', 
            this.methods.get, 
            data, 
            {
                'Content-Type': 'application/json',
            }
        )
    }
}